<template>
  <router-link
    class="text-decoration-none"
    :to="{
      name: kind.slice(0, -1),
      params: { id: product._id, title: product.name.replace(/\s/g, '-') },
    }"
  >
    <div
      class="
        rounded
        border-8
        p-0
        cursor-pointer
        item-article
        p-2
        bg-white
        border
        shadow-sm
      "
    >
      <span
        class="badge badge-success mb-3"
        :class="product.discount ? '' : 'd-none'"
        >{{ product.discount }}% off</span
      >
      <!-- <div
        class="image img-squared img-thumbnail border-0 mx-auto"
        style="height: 18em; width: 18em"
        :style="
          'background-image: url(' +
          url +
          'public/images/' +
          kind +
          '/' +
          (product.images[0] ? product.images[0] : 'blank.png') +
          ')'
        "
        loading="lazy"
      ></div> -->
      <div class="image img-squared img-thumbnail border-0 mx-auto d-flex" style="height: 18em; width: 18em; align-items: center">
        <img
        style="height: auto; width: 18em; max-width: 100%; max-height: 100%"
        :src="url + 'public/images/' + kind + '/' + (product.images[0] ? product.images[0] : 'blank.png')"
        loading="lazy"
      />
      </div>
      <hr />
      <p class="text-center pt-2 text-dark product-name">{{ product.name }}</p>
      <h5
        v-show="priceSacoinWDiscount"
        class="text-danger-2 text-center font-weight-bold"
      >
        SC$ {{ priceSacoinWDiscount }}
      </h5>
      <div class="text-center" :class="product.discount ? '' : 'mb-4'">
        <span class="text-muted"
          >({{
            product.currency == "USA"
              ? "USD"
              : product.currency
              ? product.currency
              : "USD"
          }}$ {{ priceWDiscount }})</span
        >
      </div>
      <div
        :class="
          product.discount ? 'd-inline text-center' : 'd-none text-center'
        "
      >
        <div class="old-price">
          <h5 class="text-danger-2 text-center font-weight-bold d-inline">
            SC$ {{ priceSacoin }}
          </h5>
          <div class="d-inline">
            <span class="text-muted">
              <small class="my-auto"
                >{{
                  product.currency == "USA"
                    ? "USD"
                    : product.currency
                    ? product.currency
                    : "USD"
                }}$ {{ price }})</small
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapState } from "vuex";
import Configs from "../configs/configs";
import { LC } from "../tools/exchange";
export default {
  name: "Product",
  props: {
    product: Object,
    kind: String,
  },
  data() {
    return {
      url: Configs.API.BASE,
      localCurrency: null,
    };
  },
  created: function () {
    LC.new().then((localCurrency) => {
      this.localCurrency = localCurrency;
    });
  },
  computed: {
    ...mapState(["changes"]),
    priceSacoinWDiscount() {
      if (!this.localCurrency) return 0;
      const discount = 1 - this.product.discount / 100;
      return (
        this.localCurrency.localToSC({
          price: this.product.price,
          currency: this.product.currency,
        }) * discount
      ).toFixed(2);
    },
    price() {
      return this.product.price.toFixed(2);
    },
    priceWDiscount() {
      const discount = 1 - this.product.discount / 100;
      return (this.product.price * discount).toFixed(2);
    },
    priceSacoin() {
      if (!this.localCurrency) return 0;
      return this.localCurrency
        .localToSC({
          price: this.product.price,
          currency: this.product.currency,
        })
        .toFixed(2);
    },
  },
};
</script>

<style scoped>
.old-price h5 {
  text-decoration: line-through;
  font-size: 0.8em;
}

.old-price div {
  margin-left: 0.5em;
  text-decoration: line-through;
  text-decoration-color: grey;
  font-size: 0.8em;
}

.badge {
  position: absolute;
  top: 6%;
  right: 8%;
  font-size: 1em;
}
</style>

<style lang="sass">
.item-menu-category
  padding-left: 0px
  padding-right: 5px
  transition: 0.2s
  &:hover
    color: #d31a00
    padding-left: 5px
    padding-right: 0px

.text-danger-2
  color: #d31a00

.bg-danger-2
  background-color: #d31a00

.bg-light-2
  background-color: #f6f6f5

.item-article
  transition: .1s
  &:hover
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important

.product-name
  height: 5em
  display: -webkit-box
  -webkit-line-clamp: 3
  -webkit-box-orient: vertical
  text-overflow: ellipsis
  overflow: hidden
</style>